import { EntityType } from '@frontend/common';
import { Form } from '@frontend/components/forms';
import { DeceasedClient } from '@frontend/deceased/api';
import { CreateDeceased, IDeceased } from '@frontend/deceased/types';
import { CommonMessage } from '@frontend/lang';
import { useFormValues } from '@frontend/repository';
import { WorkflowType } from '@frontend/workflow/types';
import { useMemo } from 'react';

import useDeceasedCreate from './deceased-create.controller';

const ID = 'deceased-create';

const DeceasedCreate = () => {
    const viewProps = useDeceasedCreate();
    const formValues = useFormValues<CreateDeceased>(ID);

    const fieldProps = useMemo(
        () =>
            new Map<keyof CreateDeceased, object>([
                ['workflow_id', { queryParams: { account_id: viewProps.account_id, type: WorkflowType.DECEASED } }],
                ['date_of_death', { dateTime: false }]
            ]),
        [viewProps.account_id]
    );

    return (
        <div id={ID}>
            <Form<IDeceased, CreateDeceased>
                id={ID}
                useStaticId
                type={EntityType.DECEASED}
                value={{}}
                dispatch={viewProps.dispatch}
                show={['name', 'workflow_id', 'elys_number', 'date_of_death', 'cremation_timestamp', 'spot_id']}
                keyOverwrite={
                    new Map([
                        ['elys_number', CommonMessage.OBJECTS.DECEASED.ELYS_NUMBER],
                        ['spot_id', CommonMessage.OBJECTS.SPOT.DEFAULT]
                    ])
                }
                required={['name']}
                submitDisabled={!viewProps.account_id || !formValues?.name}
                fieldProps={fieldProps}
                onCancel={viewProps.onCancel}
                onSubmit={(v) => DeceasedClient.postDeceased(viewProps.account_id!, v)}
                onSubmitSuccess={viewProps.onSubmitSuccess}
            />
        </div>
    );
};

export default DeceasedCreate;
